<template>
<b-card>
  <template #header>
    <h5 class="card-title">Cara Kerja Kami</h5>
  </template>
  <div class="d-flex align-items-center">
    <template v-if="showContent">
      <b-form-checkbox @change="$emit('updateShowSection', $event, 'home-how-we-work', apiGet)" id="preview" value="Y" unchecked-value="N" name="preview" v-model="showContent">Show Section?</b-form-checkbox>
    </template>

    <b-button 
      variant="secondary"
      class="btn-rounded ml-auto"
      v-if="previewOpen"
      @click="closePreviewForm">
      Close <i class="fas fa-times ml-2"></i>
    </b-button>
    <b-button
      variant="outline-info"
      class="btn-rounded ml-auto"
      @click="showPreviewUpdate"
      v-else
    >
      Update Content <i class="fas fa-pencil-alt ml-2"></i>
    </b-button>


  </div>
  <hr />

  <validation-observer
    v-slot="{ handleSubmit }"
    ref="VFormDescription"
    tag="div"
    v-if="previewOpen"
  >
    <b-form @submit.prevent="handleSubmit(doSubmitDesc)">
      <b-card class="border mb-0">
        <template #header>
          <h5 class="card-title">Content</h5>
        </template>
        <b-row class="mb-2">
          <b-col md=4>
            <div class="form-group">
              <label class="control-label">Title <span class="text-danger">*</span></label>         
              <b-form-input v-model="row.asc_title"  />
              <VValidate 
                name="Title" 
                v-model="row.asc_title"
                rules="required|min:3|max:160" 
              />
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md=4>
            <div class="form-group">
              <label class="control-label">Description</label>         
              <b-form-textarea :rows="3" v-model="row.asc_content"  />
              <VValidate 
                name="Description" 
                v-model="row.asc_content"
                rules="min:3" 
              />
            </div>
          </b-col>
        </b-row>
        <template #footer>
          <div class="text-right">
            <b-button variant="secondary" class="btn-rounded mr-3" @click="closePreviewForm">Cancel</b-button>
            <button type="submit" class="btn btn-info btn-rounded">Save Changes</button>
          </div>
        </template>
      </b-card>
    </b-form>
  </validation-observer>

  <template v-else>
    <div class="row justify-content-center">
      <div class="col-md-8 text-center">
        <h3>{{row.asc_title}}</h3>
        <div class="sect-heading__line"></div>
        <p>{{row.asc_content}}</p>
      </div>
    </div>

    <b-row>
      <b-col lg="6" v-for="(v, k) in howWeWork" :key="`howWeWork${k}`">
        <div class="how_it_work_wrap p-2">
          <b-row>
            <b-col md="auto">
              <div class="d-flex flex-column align-items-center">
                <div class="bullet_number">
                  <p class="m-0">{{ k + 1 }}</p>
                </div>

                <div class="button-group d-flex flex-column align-items-center mt-2">
                  <b-button type="button" @click="openModal('modalHowWeWork', {...v, keyData: k})" variant="outline-info" class="btn-icon mr-0 rounded-pill" v-b-tooltip.hover title="Update How We Work">
                    <i class="ti-pencil"></i>
                  </b-button>
                  <b-button @click="doDelete(v)" type="button" variant="outline-danger" class="btn-icon mt-1 mr-0 rounded-pill" v-b-tooltip.hover title="Delete How We Work">
                    <i class="ti-trash"></i>
                  </b-button>
                </div>
              </div>
            </b-col>
            <div class="col-md-10">
              <div class="desc_how_it_work">
                <h3>{{ v.title }}</h3>
                <p>
                  {{ v.description }}
                </p>
              </div>
            </div>
          </b-row>
        </div>
      </b-col>

      <b-col lg="12" class="mt-3">
        <div class="text-center">
          <b-button variant="outline-primary" class="rounded-pill" @click="openModal('modalHowWeWork')"><i class="ti-plus"></i> Add How We Work</b-button>
        </div>
      </b-col>
    </b-row>

    <b-modal id="modalHowWeWork" :title="(howWeWorkRow.typeLabel == 'Added' ? 'Add' : 'Update') + ' How We Work'" size="md">
      <validation-observer v-slot="{ handleSubmit }" ref="VFormHowWeWork">
        <b-form @submit.prevent="handleSubmit(doSubmit)">

          <b-row>
            <b-col md=12>
              <div class="form-group mb-2">
                <label class="control-label">Title <span class="text-danger">*</span></label>
                <input type="text" class="form-control" placeholder="Title" v-model="howWeWorkRow.title">
                <VValidate name="Title" v-model="howWeWorkRow.title" :rules="{required: true, min: 3, regex:/^[^\s]+(\s+[^\s]+)*$/}" />
              </div>
            </b-col>
            <b-col md=12>
              <div class="form-group mb-2">
                <label class="control-label">Description <span class="text-danger">*</span></label>
                <b-form-textarea :rows="3" v-model="howWeWorkRow.description"></b-form-textarea>
                <VValidate name="Description" v-model="howWeWorkRow.description" :rules="{ required: true, min: 3 }" />
              </div>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      <template #modal-footer="{close}">
        <div class="text-right">
          <b-button class="btn-rounded" variant="outline-secondary" @click="close">Cancel</b-button>
          <b-button type="button" @click="doSubmit" class="btn-rounded ml-2" variant="primary">Save Changes</b-button>

        </div>
      </template>
    </b-modal>
  </template>

</b-card>
</template>

<script>
import Gen from '@/libs/Gen.js'
// let _ = global._

export default {
  components: {},
  props: {
    modulePage: String
  },
  data() {
    return {
      previewOpen: false,
      howWeWorkRow: {},
      row: {},
      howWeWork: [],
      configCKEditor: ['heading', '|', 'bold', 'italic', 'underline', 'strikethrough', 'link', 'bulletedList', 'numberedList', 'blockQuote'],
      validation: {},
      showCompanyBrief: false,
      showContent: null
    }
  },
  computed: {
    parent() {
      return this.$parent.$parent.$parent
    }
  },
  mounted() {
    this.apiGet()
  },
  methods: {
    showPreviewUpdate() {
      this.previewOpen = true
    },
    closePreviewForm() {
      this.previewOpen = false
    },
    openModal(modal, data = null) {
      this.$bvModal.show(modal)

      this.$set(this, 'howWeWorkRow', {
        typeLabel: 'Added'
      })
      if (data) this.$set(this, 'howWeWorkRow', {
        ...this.howWeWorkRow,
        ...data,
        typeLabel: 'Updated'
      })
    },
    doDelete(data){
      this.$swal.fire({
        title: "Do You Really Want to Delete This Data",
        text: "Data that has been deleted can't recover anymore.",
        icon: 'warning',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Yes, Delete Data",
        cancelButtonText: "No, Cancel",
      }).then(button => {
        if(button.isConfirmed){
          this.parent.swalLoading()
          let howWeWork = this.howWeWork.filter(dtHowWeWork => dtHowWeWork.title != data.title)

          Gen.apiRest('/do/' + this.modulePage, 
              { data: { type: 'updateHowWeWork', ac_value: howWeWork, type_label: "Deleted" } }
            ).then(res => {
              if(res){
                this.$swal({
                  title: res.data.message,
                  icon: 'success',
                }).then(() => {
                  this.$bvModal.hide('modalHowWeWork')
                  this.apiGet()
                })
              }
            }).catch(err => {
              this.$swal({title: err.response.data.message, icon:'error'})
            })
        }
      })
    },    
    doSubmit() {
      this.$refs.VFormHowWeWork.validate().then(success => {
        if (!success) return

        this.parent.swalLoading()
        let howWeWork

        if (!this.howWeWork.length) {
          howWeWork = [{
            ...this.howWeWorkRow,
            typeLabel: null
          }]
        } else {
          if (this.howWeWorkRow.typeLabel == "Updated") {
            howWeWork = this.howWeWork.map((dtHowWeWork, kHowWeWork) => {
              if (kHowWeWork == this.howWeWorkRow.keyData) return {
                ...this.howWeWorkRow,
                keyData: null
              }
              return dtHowWeWork
            })
          } else {
            howWeWork = [...this.howWeWork, {
              ...this.howWeWorkRow,
              typeLabel: null
            }]
          }
        }

        Gen.apiRest('/do/' + this.modulePage, {
          data: {
            type: 'updateHowWeWork',
            ac_value: howWeWork,
            type_label: this.howWeWorkRow.typeLabel
          }
        }).then(res => {
          if (res) {
            this.$swal({
              title: res.data.message,
              icon: 'success',
            }).then(() => {
              this.$bvModal.hide('modalHowWeWork')
              this.apiGet()
            })
          }
        }).catch(err => {
          this.$swal({
            title: err.response.data.message,
            icon: 'error'
          })
        })
      })
    },
    doSubmitDesc() {
      this.$refs.VFormDescription.validate().then(success => {
        if (!success) return

        this.parent.swalLoading()

        Gen.apiRest('/do/' + this.modulePage, {
          data: {
            type: 'updateHowWeWorkDescription',
            ...this.row
          }
        }).then(res => {
          if (res) {
            this.$swal({
              title: res.data.message,
              icon: 'success',
            }).then(() => {
              this.closePreviewForm()
              this.apiGet()
            })
          }
        }).catch(err => {
          this.$swal({
            title: err.response.data.message,
            icon: 'error'
          })
        })
      })
    },
    apiGet() {
      Gen.apiRest('/get/' + this.modulePage + '/how_we_work', {}, 'GET').then(res => {
        this.row = res.data.row
        this.howWeWork = res.data.howWeWork
        this.validation = res.data.validation
        this.showContent = res.data.showContent
      })
    }
  }
}
</script>
